import * as React from "react";
import { CorrectionItemPreviewProps, CorrectionItemPreview } from "../WizardTypings";
import { Correction, VisibleWizards } from "../../../Request/DcfRequestReducer";
import { CorrectionBreakdownItem } from "../../CorrectionBreakdownItem";
import { Session, Subject, Visit, WebPortalClient } from "webportalclient";
import LoadingWithMessage from "../../../../misc/components/LoadingWithMessage";
import { useWebPortalApiClient } from "../../../../misc/api/WebPortalTokenClient";

interface SwapLabelsPreviewItemConnectedProps {
    subjects: Array<Subject>;
    visits: Array<Visit>;
    sessions: Array<Session>;
}

const PreviewSelector = (corrections: Correction[]): boolean => {
    return corrections.length === 3
        && corrections.find(c => c.entity === "Session" && c.field === "SubjectId") !== undefined
        && corrections.find(c => c.entity === "Session" && c.field === "VisitId") !== undefined
        || corrections.find(c => c.entity === "Session" && c.field === "SessionId") !== undefined;
}

export const SwapLabelsPreviewItem = ({ corrections }: CorrectionItemPreviewProps & SwapLabelsPreviewItemConnectedProps) => {
    const { client } = useWebPortalApiClient();
    const [subjects, setSubjects] = React.useState([]);
    const [visits, setVisits] = React.useState([]);
    const [sessions, setSessions] = React.useState([]);

    React.useEffect(() => {
        const getData = async () => {
            const subjectCorrections = corrections.find(c => c.field === "SubjectId");
            const subjectResponse = await client.getSubjects(undefined, `id eq ${subjectCorrections.oldValue} or id eq ${subjectCorrections.newValue}`, "id,number");
            setSubjects(subjectResponse.value);

            const visitCorrections = corrections.find(c => c.field === "VisitId");
            const visitResponse = await client.getVisits(undefined, `id eq ${visitCorrections.oldValue} or id eq ${visitCorrections.newValue}`, "id,name");
            setVisits(visitResponse.value);

            const sessionCorrections = corrections.find(c => c.field === "SessionId");
            const sessionResponse = await client.getSessions(undefined, `id eq ${sessionCorrections.oldValue} or id eq ${sessionCorrections.newValue}`, "id,name");
            setSessions(sessionResponse.value);
        }

        getData();
    }, [corrections, client]);

    if (!(PreviewSelector(corrections))) {
        return null;
    }

    if (subjects.length === 0 || visits.length === 0 || sessions.length === 0)
        return <LoadingWithMessage message="Loading Corrections Preview..." />;

    const getLabel = (field: string, value: string) => {
        let label = "";
        switch (field) {
            case "SubjectId":
                label = subjects.find(s => s.id === value)?.number;
                break;
            case "VisitName":
                label = value;
                break;
            case "Label":
                label = value;
                break;
            default:
                return null;
        }
        return label;
    }


    return (<>
        {corrections.filter(x => x.field !== "VisitId" && x.field !== "SessionId").map(c => {
            return (<CorrectionBreakdownItem
                fieldName={c.field}
                from={<SwapLabelsDisplay entityLabel={{ id: c.oldValue, label: getLabel(c.field, c.oldValue) }} />}
                to={<SwapLabelsDisplay entityLabel={{ id: c.newValue, label: getLabel(c.field, c.newValue) }} />}
            />);
        })}
    </>);
};

export const SwapLabelsPreview: CorrectionItemPreview = {
    previewElement: SwapLabelsPreviewItem,
    previewSelector: PreviewSelector
};

export interface SwapLabelsDisplayProps {
    entityLabel: any;
}

export const SwapLabelsDisplay = ({ entityLabel }: SwapLabelsDisplayProps) => {
    return (
        <span>{entityLabel.label}</span>
    );
}
